<div class="container-fluid">
  <div class="row mt-2 mb-5">
    <div class="col d-flex justify-content-md-center">
      <h3>Gestione Marche & Modelli</h3>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <accordion [isAnimated]="true">
        <accordion-group heading="Marche">
          <div class="row mt-2">
            <div class="col-8">
              <button
                class="btn btn-primary"
                (click)="openAddBrandModal(addBrandTemplate)"
              >
                Crea nuova marca
              </button>
            </div>
            <div class="col-4">
              <mat-form-field class="search-input">
                <mat-label>Cerca marca</mat-label>
                <input
                  matInput
                  (input)="applyBrandsSearchFilter($event.target.value)"
                  placeholder="Nome, ID, etc."
                  #input
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <table
                mat-table
                [dataSource]="brandsDataSource"
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="vbr_id">
                  <th mat-header-cell *matHeaderCellDef>ID</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vbr_id }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vbr_name">
                  <th mat-header-cell *matHeaderCellDef>
                    Marca
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vbr_name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vbr_closed_at">
                  <th mat-header-cell *matHeaderCellDef>
                    Stato
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vbr_closed_at ? "Sospeso" : "Attivo" }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vbr_created_at">
                  <th mat-header-cell *matHeaderCellDef>
                    Creato
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vbr_created_at | date : "dd/MM/yy HH:mm" }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      aria-label="Edit item"
                      (click)="onBrandRowActionHandler(element)"
                    >
                      <mat-icon>settings</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="brandsDisplayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: brandsDisplayedColumns"
                ></tr>
              </table>
              <mat-paginator
                #brandsPaginator
                [pageSizeOptions]="[10, 50, 100]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </accordion-group>
        <accordion-group [isOpen]="true" heading="Modelli">
          <div class="row mt-2">
            <div class="col-8">
              <button
                class="btn btn-primary"
                (click)="openAddModelModal(addModelTemplate)"
              >
                Crea nuovo modello
              </button>
            </div>
            <div class="col-4">
              <mat-form-field class="search-input">
                <mat-label>Cerca modello</mat-label>
                <input
                  matInput
                  (input)="applyModelsSearchFilter($event.target.value)"
                  placeholder="Nome, ID, etc."
                  #input
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <table
                mat-table
                [dataSource]="modelsDataSource"
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="vmd_id">
                  <th mat-header-cell *matHeaderCellDef>ID</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vmd_id }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vmd_name">
                  <th mat-header-cell *matHeaderCellDef>
                    Modello
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vmd_name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vmd_brand_name">
                  <th mat-header-cell *matHeaderCellDef>
                    Marca
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vmd_brand_name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vmd_closed_at">
                  <th mat-header-cell *matHeaderCellDef>
                    Stato
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vmd_closed_at ? "Sospeso" : "Attivo" }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="vmd_created_at">
                  <th mat-header-cell *matHeaderCellDef>
                    Creato
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.vehicleModels.vmd_created_at | date : "dd/MM/yy HH:mm" }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      aria-label="Edit item"
                      (click)="onModelRowActionHandler(element)"
                    >
                      <mat-icon>settings</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="modelsDisplayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: modelsDisplayedColumns"
                ></tr>
              </table>
              <mat-paginator
                #modelsPaginator
                [pageSizeOptions]="[10, 50, 100]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </div>
  </div>
</div>

<ng-template #addBrandTemplate>
  <div class="modal-header">
    <h5 class="modal-title pull-left">Scrivi la nome della nuova marca</h5>
    <button
      type="button"
      class="close btn-close pull-right"
      aria-label="Close"
      (click)="addBrandModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="newBrandForm" (ngSubmit)="onAddBrandSubmit()">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Marca</span>
          </div>
          <input
            type="text"
            formControlName="nome"
            placeholder="Nome della marca"
            class="form-control"
            [class.is-invalid]="
              brandSubmitted && getBrandFormControls.nome.errors
            "
          />
          <div
            *ngIf="brandSubmitted && getBrandFormControls.nome.errors"
            class="invalid-feedback"
          >
            <div *ngIf="getBrandFormControls.nome.errors.required">
              la nome è un campo obbligatorio
            </div>
            <div *ngIf="getBrandFormControls.nome.errors.minlength">
              Nome troppo corta
            </div>
            <div *ngIf="getBrandFormControls.nome.errors.maxlength">
              Nome troppo lunga
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="brandErrorMessage" class="alert alert-danger my-3">
        {{ brandErrorMessage }}
      </div>
      <button [disabled]="brandLoading" class="btn btn-primary">
        <span
          *ngIf="brandLoading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Crea marca
      </button>
    </form>
  </div>
</ng-template>

<ng-template #addModelTemplate>
  <div class="modal-header">
    <h5 class="modal-title pull-left">Compila la forma</h5>
    <button
      type="button"
      class="close btn-close pull-right"
      aria-label="Close"
      (click)="addModelModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="newModelForm" (ngSubmit)="onAddModelSubmit()">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Modello</span>
          </div>
          <input
            type="text"
            formControlName="nome"
            placeholder="Nome del modello"
            class="form-control"
            [class.is-invalid]="
              modelSubmitted && getModelFormControls.nome.errors
            "
          />
          <div
            *ngIf="modelSubmitted && getModelFormControls.nome.errors"
            class="invalid-feedback"
          >
            <div *ngIf="getModelFormControls.nome.errors.required">
              la nome è un campo obbligatorio
            </div>
            <div *ngIf="getModelFormControls.nome.errors.minlength">
              Nome troppo corta
            </div>
            <div *ngIf="getModelFormControls.nome.errors.maxlength">
              Nome troppo lunga
            </div>
          </div>
        </div>
      </div>
      <mat-form-field class="brand-selector">
        <mat-label>Marca</mat-label>
        <input
          type="text"
          placeholder="Scegli"
          aria-label="marca"
          matInput
          formControlName="marca"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option
            *ngFor="let option of brandsFilteredOptions | async"
            [value]="option?.vehicleModels.vbr_name"
          >
            {{ option.vehicleModels.vbr_name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <div *ngIf="modelErrorMessage" class="alert alert-danger my-3">
        {{ modelErrorMessage }}
      </div>
      <br />
      <button [disabled]="modelLoading" class="btn btn-primary">
        <span
          *ngIf="modelLoading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Crea modello
      </button>
    </form>
  </div>
</ng-template>
